import React, { useMemo } from "react";
import styled from "styled-components";
import Sunburst from "@charty/content-classification/sunburst-chart";
import { useCurrentUserLocale } from "@radarly/core/user/use-cases";
import { DatavizSunburst } from "@radarly/models/dataviz";
import { SearchFragmentClassification } from "@radarly/models/search";
import Empty from "../../empty";
import { computeSeriesToTree } from "../compute";

const Container = styled.div`
  height: 100%;
`;

export interface SharedWidgetsClassificationSunburstInnerProps {
  loading: boolean;
  data: SearchFragmentClassification["data"];
  fragment: SearchFragmentClassification;
  dataviz: DatavizSunburst;
  className?: string;
  onClickItem?: (uid: string | number) => void;
  disableAnimation?: boolean;
}

export default function SharedWidgetsClassificationsSunburstInner({
  loading,
  data,
  fragment,
  dataviz,
  className,
  onClickItem,
  disableAnimation,
}: SharedWidgetsClassificationSunburstInnerProps) {
  const locale = useCurrentUserLocale();
  const metric = fragment.request.aggs.contentClassification.metrics[0];
  const nodesLimitByChildren = dataviz.nodesLimitByChildren;
  const nodesLimitByDepth = dataviz.nodesLimitByDepth;
  const series = useMemo(() => {
    return computeSeriesToTree(
      data ? data.aggs.contentClassification.values : [],
      metric,
      locale,
      nodesLimitByChildren,
      nodesLimitByDepth
    );
  }, [data, locale, metric, nodesLimitByChildren, nodesLimitByDepth]);
  return (
    <Empty empty={!series.children.length}>
      <Container className={className}>
        <Sunburst
          series={series}
          metric={metric}
          locale={locale}
          onClickSlice={onClickItem}
          disableAnimation={disableAnimation}
        />
      </Container>
    </Empty>
  );
}
